import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import * as yup from "yup";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useState } from "react";
import Input, { NuInput, NuMobileNumber, NuSelect, NuTextArea, NuUpload } from "../../../../Components/Utils/Input";
import UseEditData from "../../../../Components/Hooks/useEditData";
import { useLocation } from "react-router-dom";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";

const EditMyTasks = () => {
  const { Oncancel, editData, contextHolder, isLoading } = UseEditData();
  const location = useLocation();
  const data = location.state.data;
  const from = location.state.from;
  const [image, setImage] = useState({ preview: "", raw: "" });

  const [createNew, setCreateNew] = useState({
    // type: data?.type || "",
    // status: data?.status || "",
    // companyName: data?.companyName || "",
    // email: data?.email || "",
    // phone: data?.phone?.number || "",
    // countryCode: data?.phone?.countryCode || "",
    // website: data?.website || "",
    // billingAddress: data?.billingAddress || "",
    // shippingAddress: data?.shippingAddress || "",
    // crNum: data?.crNum || "",
    // vatNum: data?.vatNum || "",
    // ratings: data?.ratings || "",
    // comments: data?.comments || "",
    // country: data?.country || "",
    // city: data?.city || "",
    // state: data?.state || "",
    // district: data?.district || "",
    // postalCode: data?.postalCode || "",
    // cpName: data?.cpName || "",
    // cpEmail: data?.cpEmail || "",
    // cpDesignation: data?.cpDesignation || "",
    // cpCountryCode: data?.cpPhone?.countryCode || "",
    // cpPhone: data?.cpPhone?.number || "",
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      formData.append("agentDetails", JSON.stringify(value));
      formData.append('agentImage', image.raw);

      editData(`/agents/edit-agent/${data.agentId}`, formData, resetForm, from)

    },
  });

  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };
  return (
    <div className="w-full h-full px-4 py-2 bg-[#F1F2FB]">
      <div className="flex justify-between">
        <Breadcrumb
          items={
            [{
              name: "My Task",
              link: "/tasks/my-tasks"
            },
            {
              name: "Edit My Tasks"
            }]
          }
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-200px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap  overflow-y-auto">
            {/* <FormikSelectTwo
              type="text"
              label="Agent Type"
              placeholder="Agent Type"
              Options={[
                { value: "Shipping", label: "Shipping" },
                { value: "Cargo", label: "Cargo" },
              ]}
              formik={formik}
              name="type"
              width="w-full md:w-1/3"
            />
            <FormikSelectTwo
              type="text"
              label="Status"
              placeholder="Category"
              Options={[
                { value: "Active", label: "Active" },
                { value: "In Active", label: "In Active" },
              ]}
              formik={formik}
              name="status"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="Company Name"
              placeholder="Company Name"
              formik={formik}
              name="companyName"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              width="w-full md:w-1/3"
            />
            <NuMobileNumber
              nunCode="countryCode"
              label="phone"
              placeholder="phone"
              formik={formik}
              name="phone"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="website"
              placeholder="website"
              formik={formik}
              name="website"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="Billing Address"
              placeholder="billingAddress"
              formik={formik}
              name="billingAddress"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="Shipping Address"
              placeholder="shippingAddress"
              formik={formik}
              name="shippingAddress"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="number"
              label="crNum"
              placeholder="crNum"
              formik={formik}
              name="crNum"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="number"
              label="Vat Num"
              placeholder="vatNum"
              formik={formik}
              name="vatNum"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="number"
              label="Ratings"
              placeholder="ratings"
              formik={formik}
              name="ratings"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="Country"
              placeholder="country"
              formik={formik}
              name="country"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="State"
              placeholder="state"
              formik={formik}
              name="state"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="District"
              placeholder="district"
              formik={formik}
              name="district"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="City"
              placeholder="city"
              formik={formik}
              name="city"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="number"
              label="Postal Code"
              placeholder="postalCode"
              formik={formik}
              name="postalCode"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="Contact Person Name"
              placeholder="cpName"
              formik={formik}
              name="cpName"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="email"
              label="Contact Person Email"
              placeholder="cpEmail"
              formik={formik}
              name="cpEmail"
              width="w-full md:w-1/3"
            />
            <NuInput
              type="text"
              label="Contact Person Desigation"
              placeholder="Contact Person Desigation"
              formik={formik}
              name="cpDesignation"
              width="w-full md:w-1/3"
            />
            <NuMobileNumber
              nunCode="cpCountryCode"
              label="phone"
              placeholder="phone"
              formik={formik}
              name="cpPhone"
              width="w-full md:w-1/3"
            />
            <NuTextArea
              label="Comments"
              placeholder="crNum"
              formik={formik}
              name="comments"
              width="w-full md:w-1/3"
            />
            <NuUpload
              label="Attachment"
              width="w-full md:w-1/3"
              onChange={handleChangeImg}
            /> */}

            <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
              <div className="md:flex justify-end gap-4">
                <CancelButton handleClick={() => { Oncancel(-1) }} />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditMyTasks;
